import React, { useContext, } from 'react';
import { PermissionsContext } from '../../router/DashboardRoutes';

export const Restricted = ({to, ...props}) => {

    const userPermissions = useContext(PermissionsContext);

    const getPermission = () => {

        if (to){
            return to.replace(/\[([^\]]+)]/g, '.$1').split('.').reduce(function(o, p) { 
                return o[p];
            }, userPermissions);
        } 
        
        return false;
    }
    
    return (
        <>
            { getPermission()  &&
                props?.children 
            }
        </>
    )
}

Restricted.defaultParams = {
    to: '',
}